import { call, put, delay, takeLatest } from 'redux-saga/effects';
import { verifyEmailSuccess, verifyEmailFailure } from '../actions/authActions';
import { verifyEmailApi } from '../Effects/AuthEffect';
import { VERIFY_EMAIL_REQUEST } from '../types/AuthTypes';

function* verifyEmailSaga(action) {
  const { email, verification_code } = action.payload;
  try {
    const response = yield call(verifyEmailApi, { email, verification_code });

    yield put(verifyEmailSuccess(response.message));
  } catch (error) {
    yield put(verifyEmailFailure(error));
  }
}

export function* watchVerifyEmailSaga() {
  yield takeLatest(VERIFY_EMAIL_REQUEST, verifyEmailSaga);
}
